import styled from '@emotion/styled'

import {cssTheme} from '@vio/atlas/themes'

export const OverlayContent = styled('div')`
  display: flex;
  flex-direction: column;
  height: 100%;
`

export const MapContainer = styled('div')`
  height: 100%;
`

// Extend map under next sibling and push controls up to compensate
export const ExtendedMapContainer = styled('div')`
  flex-grow: 1;

  & > ${MapContainer} {
    height: calc(100% + ${cssTheme.layout.radius.lg});
  }

  & .mapboxgl-ctrl-bottom-left,
  & .mapboxgl-ctrl-bottom-right {
    bottom: ${cssTheme.layout.radius.lg};
  }
`

export const MapOverlapBottomCTAPositioner = styled('div')`
  /* BottomCTA overlapping part is put on top of the map renderer which is positioned absolute */
  z-index: 2;
`
